var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0.00390625,
    width: 60,
    height: 60,
    rx: 30,
    transform: "rotate(90 60 0.00390625)",
    fill: "white",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0887 29.4279L40.3019 29.4279M40.3019 29.4279L32.4865 37.2433M40.3019 29.4279L31.9283 21.0543",
    stroke: "#292D32",
    strokeOpacity: 0.6,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c130d031d02db81d6ca0b357b15414ee.svg";
export { ForwardRef as ReactComponent };